<template>
 <div class="login-bg min-h-screen p-4 flex items-center justify-center flex-col">
   <div class="login-wrapper p-4 w-full  relative z-50   ">
  <img src="@/assets/logo.svg" alt="" class="mx-auto pt-12 ">
  <h1 class="text-black text-base font-medium text-center py-8">HRMS Login</h1>

  <div class="">
    <form @submit.prevent="submit">
      <input type="email" name="email" id="email" placeholder="Email Address" class="w-full rounded-t-lg p-4 text-sm border border-divider border-b-0 outline-none" autocomplete="username" v-model="emailAddress" required autocapitalize="none">
      <input type="password" name="current-password" id="current-password" placeholder="Password" class="w-full rounded-b-lg p-4 text-sm border border-divider outline-none" autocomplete="current-password" v-model="password" required>
      <button type="submit" :class="`btn-login font-bold text-white w-full mt-8 p-4 mb-7 block text-center ${!emailAddress || !password ? 'disabled': ''}`">Login</button>
    </form>
   
  </div>
   </div>
   <Loader v-if="isLoading"/>
 </div>
</template>

<script>
import Loader from '../components/Loader.vue';
export default {
  name: 'Login',
  components:{
    Loader
  },
  data(){
    return {
      isLoading:false,
      emailAddress:'',
      password:''
    }
  },
  methods:{
    async submit(){
      try{
        this.isLoading = true;
        const res = await this.$axios.post('/login',{email:this.emailAddress,password:this.password});
        const data = res.data;
        if(data && data.status){
          localStorage.setItem('ipl-user-token',data.data.token);
          localStorage.setItem('ipl-user-name',data.data.name);
          localStorage.setItem('ipl-user-email',this.emailAddress);
          this.$router.replace("/");
        }
        this.isLoading = false;

      }catch(err){
        if(err && err.data && err.data.message){
          this.$swal("Login Failed",err.data.message,"error");
        }else{
          this.$swal("Login Failed","Something went wrong!","error");
        }
        this.isLoading = false;
      }
    }
  }
}
</script>
<style scoped>

.login-bg {
  background: #0c2c45;
  position: relative;
  mix-blend-mode: multiply;
 
}
 .login-bg::after {
    position: absolute;
    content: '';
    background: url(../assets/bg-login-full.jpg) no-repeat bottom;
    height: 558px;
    width: 100%;
    bottom:0;
    left:0;
    z-index: 0;
    background-size: cover;
  }
.login-wrapper {
  background: linear-gradient(180deg, #FAFAFA 0%, #F5F5F5 100%);
  border-radius: 10px;
}
.btn-login {
  background: linear-gradient(180deg, #FF9C59 0%, #ED6C15 100%);
  box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.16);
  -webkit-tap-highlight-color:transparent;
  border-radius: 10px;
}
.btn-login:active{
  outline: none;
  box-shadow: none;
}
.btn-login.disabled{
  background: linear-gradient(180deg, #FF9C5999 0%, #ED6C1599 100%);
  box-shadow: none;
}
</style>
